<script>
import Prototype from '../Prototype.vue';
export default {
  name: 'Single',
  extends: Prototype
};
</script>
